import './App.css';
import InventorControlPanel from './InventorControlPanel';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
    <InventorControlPanel/>
    </div>
  );
}

export default App;
